export const UI_FILE_STRINGS = {
  CHECKING: "prüfe",
  UNCHECKED_STATE: "ungeprüft",
  VIRUS_FREE: "in Ordnung",
  THREAT_FOUND: "Virus gefunden",
};
